import React, { memo, useState } from 'react'
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
  } from 'reactstrap';
  import "../cardtab.css"
import { imageBaseUrl } from '../../../../utils/constants';

const AssignedInvestigators = memo((props) => {
    const [open, setOpen] = useState('0');
    const toggle = (id) => {
      if (open === id) {
        setOpen();
      } else {
        setOpen(id);
      }
    };
    return (
        <div className='assignedInvestigators'>
            <Accordion open={open} toggle={toggle}>
                <AccordionItem>
                    <AccordionHeader targetId="1">Assigned Investigators - {props?.assigned_investigators && props?.assigned_investigators?.count}</AccordionHeader>
                    <AccordionBody accordionId="1">
                        {props?.assigned_investigators && props?.assigned_investigators?.investigators && props?.assigned_investigators?.investigators.map((item,index) => {
                            return (
                                <div className='row invList' key={index}>
                                    {item.map((data, innerIndx) => {
                                        return (
                                            <div className='col-4' key={innerIndx}>
                                                <div className='label'>{data?.label} :</div>
                                                <div className='value' title={data?.value}>{data?.value}</div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        })}
                        <button className='toggle' onClick={toggle}>
                            <img src={`${imageBaseUrl}/assign_not_collapsed.png`} alt="toggleimg"></img>
                        </button>
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        </div>
    )
})

AssignedInvestigators.propTypes = {}

export default AssignedInvestigators